<template>
  <div class="login-container">
    <el-form :model="form" :rules="rules" hide-required-asterisk ref="form">
      <img :src="baseUrl + logo" alt="" v-if="logo">
      <el-radio-group size="small" v-model="loginType">
        <el-radio :label="1">账号登录</el-radio>
        <el-radio :label="2">验证码登录</el-radio>
      </el-radio-group>
      <template v-if="loginType === 1">
        <el-form-item label="用户名" prop="userName">
          <el-input v-model="form.userName" placeholder="请输入用户名" clearable></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password" type="password" show-password placeholder="请输入密码" clearable></el-input>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item label="手机号" prop="mobilePhone">
          <el-input v-model="form.mobilePhone" placeholder="请输入手机号" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号" style="display: none">
          <el-input v-model="form.mobilePhone" placeholder="请输入手机号" clearable></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="verifyCode">
          <el-input placeholder="请输入短信验证码" v-model="form.verifyCode" clearable>
            <el-button slot="append" @click="sendVerifyCode" :disabled="isCounting">{{ this.isCounting ?
              `${this.countdown}秒后重试` : "发送验证码" }}</el-button>
          </el-input>
        </el-form-item>
      </template>
      <el-button class="login-btn" type="primary" @click="login">登 录</el-button>
    </el-form>
  </div>
</template>

<script>
const { jumpURL } = projectConfig
import * as api from './api'
import { getConfigInfo } from '../../layout/api'
import md5 from '@/utils/md5'
export default {
  name: 'Login',
  data() {
    var validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else {
        if (/^1[3-9]\d{9}$/.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的手机号'))
        }
      }
    }
    return {
      baseUrl: localStorage.getItem('baseUrl'),
      logo: localStorage.getItem('logo'),
      loginType: 1,
      form: {
        userName: '',
        password: '',
        mobilePhone: '',
        verifyCode: ''
      },
      rules: {
        userName: [{ required: true, trigger: 'change', message: '用户名不能为空' }],
        password: [{ required: true, trigger: 'change', message: '密码不能为空' }],
        mobilePhone: [{ validator: validatePhone, trigger: 'blur' }],
        verifyCode: [{ required: true, trigger: 'change', message: '验证码不能为空' }]
      },
      redirect: '',
      isCounting: false,
      countdown: 60
    }
  },
  beforeCreate() {
    // 设备类型
    const isMobile = /Mobile|Android|iPhone/i.test(navigator.userAgent)
    if (isMobile) return window.location.href = `${jumpURL}/mobile/`
  },
  async created() {
    // 背景图
    const { data: { settingValue } } = await getConfigInfo('login_bg')
    document.querySelector('.login-container').style.backgroundImage = `url(${this.baseUrl}${settingValue})`
  },
  methods: {
    sendVerifyCode() {
      if (!/^1[3-9]\d{9}$/.test(this.form.mobilePhone)) {
        this.$refs.form.validateField('mobilePhone')
        return
      }
      this.startCountdown()
      api.getVerifyCode({
        mobilePhone: this.form.mobilePhone,
        verifyCode: md5(this.form.mobilePhone)
      })
    },
    startCountdown() {
      this.isCounting = true
      const timer = setInterval(_ => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          clearInterval(timer)
          this.isCounting = false
          this.countdown = 60
        }
      }, 1000)
    },
    login() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const { data: { token, expireTime } } = this.loginType === 1 ? await api.accountLogin(this.form) : await api.phoneLogin(this.form)
          this.redirect = this.$route.query.redirect_url
          if (this.redirect) {
            window.location.href = `${decodeURIComponent(this.redirect)}&token=${token}&expireTime=${expireTime}`
          } else {
            localStorage.setItem('sys_token', token)
            localStorage.setItem('expireTime', expireTime)
            this.$router.push('/home')
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(../../assets/login_bg.jpg);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  ::v-deep.el-form {
    padding: 100px;
    background: #fff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &-item__label {
      font-weight: bold;
      line-height: 2rem;
    }

    img {
      height: 40px;
      margin: auto;
    }

    .el-radio-group {
      margin: 50px 0 30px;
    }

    &-item__content {
      width: 300px;
    }

    .login-btn {
      width: 100%;
      margin-top: 20px;
    }
  }
}
</style>
